"use client";

import { Badge } from "@/components/ui/badge";
import { X } from "lucide-react";

interface TagBadgeItemProps {
  tag: string;
  isLoading: boolean;
  onRemove: (tag: string) => void;
}

export function TagBadgeItem({ tag, isLoading, onRemove }: TagBadgeItemProps) {
  return (
    <Badge
      variant="secondary"
      className="text-xs font-medium bg-purple-50 text-purple-700 border-purple-200 hover:bg-purple-100 dark:bg-purple-950/40 dark:text-purple-300 dark:border-purple-800 dark:hover:bg-purple-900/40 transition-colors group relative pr-1"
    >
      <span>{tag}</span>
      <button
        type="button"
        onClick={() => onRemove(tag)}
        disabled={isLoading}
        className="ml-1 inline-flex items-center justify-center h-4 w-4 rounded hover:bg-purple-200 dark:hover:bg-purple-900/50 transition-colors disabled:opacity-50"
        title="Remove tag"
      >
        <X className="h-3 w-3" />
      </button>
    </Badge>
  );
}
